import React from "react";
import "../ui/ui.scss";

/**
 * The fills `.ui-progress__fill--*` defines. The hue names are what the existing
 * call sites pass; the tone names are what a new one should reach for, because
 * a meter's colour says how things are going, not which hue it is.
 */
const FILLS = new Set(["primary", "emerald", "blue", "violet", "amber", "rose"]);
const TONE_FILLS = { success: "emerald", warning: "amber", danger: "rose", info: "blue" };

const warned = new Set();
const resolveFill = (color) => {
  if (FILLS.has(color)) return color;
  if (TONE_FILLS[color]) return TONE_FILLS[color];
  if (process.env.NODE_ENV !== "production" && !warned.has(color)) {
    warned.add(color);
    // eslint-disable-next-line no-console
    console.warn(
      `[ProgressBar] unknown color "${color}" — falling back to "primary". ` +
        `Valid: ${[...FILLS, ...Object.keys(TONE_FILLS)].join(", ")}.`
    );
  }
  return "primary";
};

/**
 * ProgressBar — Thin animated progress indicator.
 *
 * Props:
 *   value     — 0-100 percentage
 *   size      — sm | md | lg  (height)
 *   color     — primary | success | warning | danger | info, or the older
 *               emerald | blue | violet | amber | rose
 *   className — Extra class
 */
const ProgressBar = ({ value = 0, size = "sm", color = "blue", className = "" }) => (
  <div className={`ui-progress ui-progress--${size} ${className}`}>
    <div
      className={`ui-progress__fill ui-progress__fill--${resolveFill(color)}`}
      style={{ width: `${Math.min(Math.max(value, 0), 100)}%` }}
    />
  </div>
);

export default ProgressBar;
